import { render } from "./AllPosts.vue?vue&type=template&id=747a8068"
import script from "./AllPosts.vue?vue&type=script&lang=js"
export * from "./AllPosts.vue?vue&type=script&lang=js"

import "./AllPosts.vue?vue&type=style&index=0&id=747a8068&lang=scss"
script.render = render

export default script